var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntegra(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 221.441,
    height: 79.455,
    viewBox: "0 0 221.441 79.455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1573",
    "data-name": "Rectangle 1573",
    width: 221.441,
    height: 79.455,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1575",
    "data-name": "Rectangle 1575",
    width: 23.347,
    height: 20.615,
    transform: "translate(198.094 32.857)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -8.485,
    y1: 2.26,
    x2: -8.442,
    y2: 2.26,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51b748"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_590",
    "data-name": "Group 590",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1570",
    "data-name": "Rectangle 1570",
    width: 4.165,
    height: 29.687,
    transform: "translate(0 23.744)",
    fill: "#6a747c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_585",
    "data-name": "Group 585"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_584",
    "data-name": "Group 584",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_731",
    "data-name": "Path 731",
    d: "M35.1,53.431,20.03,34.285a30.959,30.959,0,0,1-3.182-4.414h-.094c.094.99.14,2.207.14,3.693V53.431H12.729V23.744h4.258L31.448,42.168A30.787,30.787,0,0,1,34.817,46.9h.093c-.046-1.127-.093-2.389-.093-3.875V23.744h4.165V53.431Z",
    fill: "#6a747c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_732",
    "data-name": "Path 732",
    d: "M66.453,27.3H57.842V53.43H53.631V27.3H44.786V23.744h22.93Z",
    fill: "#6a747c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_733",
    "data-name": "Path 733",
    d: "M72.771,53.431V23.744h15.77L87.185,27.3H76.936v9.189H87.091v3.513H76.936v9.866h11.7v3.559Z",
    fill: "#6a747c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_734",
    "data-name": "Path 734",
    d: "M109.835,53.88c-9.5,0-15.725-5.63-15.725-14.73,0-9.279,6.6-15.632,16.426-15.632a22.73,22.73,0,0,1,8.75,1.713l-.047,4.1a19.375,19.375,0,0,0-8.61-2.252c-7.908,0-12.025,4.91-12.025,11.893,0,6.936,4.351,11.352,11.7,11.352a11.976,11.976,0,0,0,5.756-1.083V38.881h4.164V51.537a23.86,23.86,0,0,1-10.387,2.343",
    fill: "#6a747c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_735",
    "data-name": "Path 735",
    d: "M144.371,53.43c-4.866-7.613-7.534-12.208-8.892-12.208h-2.994V53.43H128.32V23.744h7.019c7.488,0,10.435,3.648,10.435,8.153a8,8,0,0,1-5.9,7.929v.09c1.124.541,4.493,5.9,9.406,13.514ZM135.386,27.3h-2.9v10.36h2.854c3.557,0,6.084-2.387,6.084-5.36,0-2.7-1.591-5-6.037-5",
    fill: "#6a747c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    d: "M173.947,53.431l-3.136-7.749H158.878l-2.9,7.749h-4.212L163.6,23.654h2.667L178.3,53.431Zm-7.769-20.182a30.066,30.066,0,0,1-1.169-3.695h-.048a32.031,32.031,0,0,1-1.216,3.651l-3.416,9.01h9.077Z",
    fill: "#6a747c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1571",
    "data-name": "Rectangle 1571",
    width: 9.913,
    height: 8.754,
    transform: "translate(198.226 70.701)",
    fill: "#00a551"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1572",
    "data-name": "Rectangle 1572",
    width: 15.032,
    height: 13.275,
    transform: "translate(190.389 55.499)",
    fill: "#00a551"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_587",
    "data-name": "Group 587"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_586",
    "data-name": "Group 586",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1574",
    "data-name": "Rectangle 1574",
    width: 23.347,
    height: 20.615,
    transform: "translate(198.094 32.857)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_589",
    "data-name": "Group 589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_588",
    "data-name": "Group 588",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_737",
    "data-name": "Path 737",
    d: "M214.9,0,182.275,4.934l4.1,27.759L219,27.759Z",
    fill: "#50b748"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    "data-name": "Path 738",
    d: "M185.265,53.092a2.686,2.686,0,0,1,1.29.339,2.4,2.4,0,0,1,.98.97,2.633,2.633,0,0,1,.006,2.62,2.436,2.436,0,0,1-.97.971,2.636,2.636,0,0,1-2.611,0,2.448,2.448,0,0,1-.972-.971,2.63,2.63,0,0,1,0-2.62,2.422,2.422,0,0,1,.983-.97,2.685,2.685,0,0,1,1.289-.339m0,.435a2.234,2.234,0,0,0-1.076.283,2.031,2.031,0,0,0-.818.81,2.213,2.213,0,0,0-.3,1.1,2.19,2.19,0,0,0,.291,1.086,2.061,2.061,0,0,0,.811.811,2.186,2.186,0,0,0,2.176,0,2.054,2.054,0,0,0,.811-.811,2.193,2.193,0,0,0-.006-2.183,2.019,2.019,0,0,0-.818-.81,2.241,2.241,0,0,0-1.075-.283m-1.15,3.64V54.344h.97a2.373,2.373,0,0,1,.719.078.694.694,0,0,1,.355.273.726.726,0,0,1,.132.414.754.754,0,0,1-.221.539.878.878,0,0,1-.586.257.77.77,0,0,1,.24.149,3.208,3.208,0,0,1,.417.56l.345.553h-.557l-.25-.445a2.285,2.285,0,0,0-.476-.657.586.586,0,0,0-.365-.1h-.268v1.2Zm.455-1.589h.553a.888.888,0,0,0,.54-.118.4.4,0,0,0,.075-.537.406.406,0,0,0-.193-.148,1.438,1.438,0,0,0-.457-.049h-.518Z",
    fill: "#6a747c"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegra);
export default __webpack_public_path__ + "static/media/integra.d2d743951911525df4ff25f9c6b29aef.svg";
export { ForwardRef as ReactComponent };